import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#0F0F0F] text-white selection:bg-[#C1121F] selection:text-white">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
